import React from 'react';
import { Zap, AlertCircle } from 'react-feather';
import cn from 'classnames';
import LinkButton from 'components/shared/LinkButton';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ViewAutomatedAnalysisLink = ({ onClick, data }) => {
  const processingCompleted =
    data?.transcription_status === 'complete' &&
    data?.assisted_grading_status === 'complete';

  const processingPending =
    data?.transcription_status === 'pending' ||
    data?.assisted_grading_status === 'pending' ||
    data?.transcription_status === 'waiting' ||
    data?.assisted_grading_status === 'waiting';

  const processingFailed =
    data?.transcription_status === 'failed' ||
    data?.assisted_grading_status === 'failed' ||
    data?.transcription_status === 'unrecoverable' ||
    data?.assisted_grading_status === 'unrecoverable' ||
    data?.transcription_status === 'recording not found' ||
    data?.assisted_grading_status === 'recording not found';

  const containerClassNames = cn('ws-bs ta-l d-f ai-c', {
    'c-link': processingCompleted || processingFailed,
    'c-midnight-70': processingPending,
  });

  return (
    <>
      {processingFailed && (
        <>
          <div className={containerClassNames}>
            <AlertCircle height={20} className="mr-8 mt-6 c-midnight-70" />
            <Text
              variant={TEXT_VARIANTS.BODY_LIGHT}
              className="pt-12 pb-8 c-midnight-100"
            >
              {t('automated_analysis.report_card.status.failed')}
            </Text>
          </div>
          <div className={containerClassNames}>
            <LinkButton
              onClick={onClick}
              className="Underline-on-hover td-n ta-l ml-24 pl-8 va-m"
            >
              <Text variant={TEXT_VARIANTS.BODY_LINK}>
                {t('automated_analysis.report_card.status.see_more')}
              </Text>
            </LinkButton>
          </div>
        </>
      )}
      {processingPending && (
        <div className={containerClassNames}>
          <Zap height={20} className="mr-8" />
          <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="pt-12 pb-12">
            {t('automated_analysis.report_card.status.pending')}
          </Text>
        </div>
      )}
      {processingCompleted && (
        <div className={containerClassNames}>
          <Zap height={20} className="mr-8" />
          <LinkButton
            onClick={onClick}
            className="Underline-on-hover td-n ta-l pt-12 pb-12 va-m"
          >
            <Text variant={TEXT_VARIANTS.BODY_LINK}>
              {t('automated_analysis.report_card.status.completed')}
            </Text>
          </LinkButton>
        </div>
      )}
    </>
  );
};

export default ViewAutomatedAnalysisLink;
